var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"title",staticClass:"calendar-date-title"},_vm._l((_vm.dates),function(date){return _c('div',{key:("calendar-date-title__item-" + (date.toLocaleDateString())),staticClass:"calendar-date-title__item",style:({
		'min-width' : _vm.columnWidth,
	}),attrs:{"id":("calendar-date-title__item-" + (date.toLocaleDateString()))}},[_vm._v(" "+_vm._s(_vm.calcTitle(date))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }